//行政月常规采购申请A
<template>
	<div class="pages" v-loading="listLoading">
		<div v-for='(item,index) in templateData.TemplateContent.Controls' :key='index'>
			<Digit v-if='item.Property.Control=="Number"' :data-val='item'></Digit>
			<Contact v-if='item.Property.Control=="Condition"' :data-val="item"></Contact>
			<Dates v-if='item.Property.Control=="Date"' :data-val="item"></Dates>
			<Version v-if='item.Property.Control=="Text"' @child-event='getTextVal' :data-val="item"></Version>
			<Money v-if='item.Property.Control=="Money"' :data-val="item"></Money>
			<Tips v-if='item.Property.Control=="Tips"' :data-val="item"></Tips>
			<File v-if='item.Property.Control=="File"' :data-val="item"></File>
			<Table v-if='item.Property.Control=="Table"' @child-event='tableOperation' :data-val='item' :template-data='templateData'></Table>
			<Selector v-if='item.Property.Control=="Selector"' @child-event='getSelectorVal' :data-val='item'></Selector>
			<Textarea v-if='item.Property.Control=="Textarea"' :data-val='item'></Textarea>
			<Choose v-if='item.Property.Control=="Contact"' @child-event='clickChoose' :data-val='item'></Choose>
<!--			<SelectFilterTable v-if='item.Property.Control=="SelectFilterTable"' @data-val='item' :template-data='templateData.TemplateContent.Controls'-->
<!--			 :val-index='5'></SelectFilterTable>-->
		</div>
		<!-- <TimeSlot></TimeSlot> -->
<!--		<AnswerTemplate></AnswerTemplate>-->
		<Button class="submit-process" v-on:click='submit' v-bind:disabled="isDisabled" v-bind:loading="formLoading" size="large"
		 type="primary"> 提交
		</Button>


		<!-- <el-dialog title="分佣制度" :visible.sync="dialogVisible" :fullscreen='false' custom-class="distribution-system-modal"
		 width="90%" :close-on-click-modal='false' :close-on-press-escape='false' :show-close="false">
			<span>
				<img class="distribution-system" src="../assets/image/distribution_system1.jpg" alt="分佣制度1">
				<img class="distribution-system" src="../assets/image/distribution_system2.jpg" alt="分佣制度2">
				<img class="distribution-system" src="../assets/image/distribution_system3.jpg" alt="分佣制度3">
			</span>
			<span slot="footer" class="dialog-footer">
				<el-button size="mini" @click="cancelSystem">取 消</el-button>
				<el-button size="mini" :disabled="!optBtn" type="primary" @click="readAndAgree">已阅读并同意<span v-show="!optBtn">{{timer}}</span></el-button>
			</span>
		</el-dialog> -->

	</div>
</template>

<script>
	/**
	 * Version 为Text文本组件
	 */
	// import TimeSlot from '../components/TimeSlot.vue'
	import Digit from "../components/Number.vue";
	import Contact from "../components/Contact.vue";
	import Version from "../components/Text.vue";
	import Money from "../components/Money.vue";
	import Tips from "../components/Tips.vue";
	import File from "../components/File.vue";
	import Dates from "../components/DateTime.vue";
	import Table from "../components/Table.vue";
	import Selector from "../components/Selector.vue";
	import AnswerTemplate from "../components/AnswerTemplate.vue";
	import Textarea from "../components/Textarea.vue";
	import Choose from "../components/Choose.vue";
	import TimeSlot from "../components/TimeSlot.vue";
	import stringUtils from "../assets/js/stringUtil.js";
	import {initWxConfig} from "../api/jssdk.js";
	import {getTemplateInfo, submitProcessCopy} from "@/api/approval";
	import wx from 'weixin-js-sdk';
	import {
		submitProcess,
		getAdministrativeProgressive
	} from '@/api/approval'
	import {
		getDepartmentInfo,
		getDepartmentRelationByStructs
	} from '@/api/department'
	import {
		getRelation
	} from '@/api/employee'

	var isSubmit = false;

	var template = {
		TemplateContent: {
			Controls: []
		}
	};
	var timeFn;
	export default {
		components: {
			Contact,
			Version,
			Money,
			Tips,
			File,
			Table,
			Digit,
			Selector,
			Textarea,
			Choose,
			Dates,
			// AnswerTemplate
		},
		data() {
			return {
				templateData: template,
				relationList: null,
				logInfo: null,
				templateId: "",
				spNo: null,
				flowId: null,
				formLoading: false,
				listLoading: false,
				isDisabled: false,
				dialogVisible: false,
				optBtn: false,
				timer: 30,
				
			}
		},
		created() {
			this.logInfo = this.getLoginUserInfo();
			initWxConfig(this);
			this.templateId = this.$route.query.templateId;
			this.spNo = this.$route.query.spNo;
			this.flowId = this.$route.query.flowId;
			this.getTemplate();
			stringUtils.setAddIsShow(true);
		},
		methods: { //方法
		
			//点击提交时显示协议弹窗并且开始30后才可点击的倒计时
			checkModal() {
				this.dialogVisible = true;
				this.downTime()
			},
			// 30秒倒计时
			downTime(val){
				let that = this;
				timeFn=setInterval(function(){
					that.timer--;
					if (that.timer == 0) {
						clearInterval(timeFn);
					} 
				},1000)
			},
			// 点击取消按钮
			cancelSystem(){
				this.dialogVisible = false;
				clearInterval(timeFn);
			},
			// 点击已阅读并同意按钮
			readAndAgree(){
				this.dialogVisible = false;
				clearInterval(timeFn);
				this.submit();
			},
			clickChoose: async function(dataVal, name) {
				var that = this;
				window.wx.invoke("selectEnterpriseContact", {
					"fromDepartmentId": 0, // 必填，表示打开的通讯录从指定的部门开始展示，-1表示自己所在部门开始, 0表示从最上层开始
					"mode": "multi", // 必填，选择模式，single表示单选，multi表示多选
					"type": ["user", "department"], // 必填，选择限制类型，指定department、user中的一个或者多个
					"selectedDepartmentIds": [], // 非必填，已选部门ID列表。用于多次选人时可重入，single模式下请勿填入多个id
					"selectedUserIds": [] // 非必填，已选用户ID列表。用于多次选人时可重入，single模式下请勿填入多个id
				}, async function(res) {
					if (res.err_msg == "selectEnterpriseContact:ok") {
						if (typeof res.result == 'string') {
							res.result = JSON.parse(res.result) //由于目前各个终端尚未完全兼容，需要开发者额外判断result类型以保证在各个终端的兼容性
						}
						var depart = res.result.departmentList[0]; // 已选的部门列表
						var DepAssignment = true;
						var departFullName = "";
						await getDepartmentInfo(depart.id).then(res => {
							departFullName = res.Body.FullName;
						});

						if (that.logInfo.fullName.indexOf("小战区") > -1) {
							if (departFullName.indexOf("小战区") > -1) {
								DepAssignment = true;
							} else {
								DepAssignment = false;
								alert("只能选择住宅部下小战区或小战区下级部门！");
							}

						} else if (that.logInfo.fullName.indexOf("工商铺") > -1) {
							if (departFullName.indexOf("工商铺") > -1) {
								DepAssignment = true;
							} else {
								DepAssignment = false;
								alert("只能选择工商铺或工商铺下级部门！");
							}
						} else if (that.logInfo.fullName.indexOf("房友圈") > -1) {
							if (departFullName.indexOf("房友圈") > -1) {
								DepAssignment = true;
							} else {
								DepAssignment = false;
								alert("只能选择房友圈或房友圈下级部门！");
							}
						} else if (that.logInfo.fullName.indexOf("二级市场") > -1) {
							if (departFullName.indexOf("二级市场") > -1) {
								DepAssignment = true;
							} else {
								DepAssignment = false;
								alert("只能选择二级市场或二级市场下级部门！");
							}
						} else if (that.logInfo.fullName.indexOf("按揭金融服务中心") > -1) {
							if (departFullName.indexOf("按揭金融服务中心") > -1) {
								DepAssignment = true;
							} else {
								DepAssignment = false;
								alert("只能选择按揭金融服务中心或按揭金融服务中心下级部门！");
							}
						} else if (that.logInfo.fullName.indexOf("非营业") > -1) {
							if (departFullName.indexOf("非营业") > -1) {
								DepAssignment = true;
							} else {
								DepAssignment = false;
								alert("只能选择非营业或非营业下级部门！");
							}
						} else if (that.logInfo.fullName.indexOf("原友信") > -1) {
							if (departFullName.indexOf("原友信") > -1) {
								DepAssignment = true;
							} else {
								DepAssignment = false;
								alert("只能选择原友信或原友信下级部门！");
							}
						} else {
							DepAssignment = false;
						}
						that.templateData.TemplateContent.Controls.forEach(async (item, index) => {
							if (item.Property.Title[0].Text == "流程部门") {
								if (departFullName.indexOf("住宅部") > -1) {
									item.Value = "option-1600932004491";
									item.IsShow = false;
								}
								if (departFullName.indexOf("工商铺商业运营中心") > -1) {
									item.Value = "option-1600932004492";
									item.IsShow = false;
								}
								if (departFullName.indexOf("房友圈") > -1) {
									item.Value = "option-1600932020690";
									item.IsShow = false;
								}
							}
							if (item.Property.Title[0].Text == "小战区区董") {
								item.Values = await that.getDepartmentRelation(depart.id, "区域董事", true)
								if (item.Values == null || item.Values.length <= 0) {
									//审批节点无人，跳过
									item.Values.push(that.$store.state.defaultMember);
								}
								item.IsShow = false;
							}
							if (item.Property.Title[0].Text == "行政主任") {
								getDepartmentRelationByStructs(departFullName, "行政主任", false).then(res => {
									if (res.Body != null) {
										res.Body[0].Nodes.forEach((depData) => {
											if (depData.Items != null) {
												depData.Items.forEach((userData) => {
													if (userData.PositionName == "行政主任") {
														item.Values = [];
														var insertDat = [userData.EmpNo, userData.EmpName]
														item.Values.push(insertDat);
													}
												})
											}
										});
									} else {
										item.Values = [
											["SC24000029", "钟志斌"]
										]
									}

								})
								item.IsShow = false;
							}
						})
						if (DepAssignment) {
							dataVal.Values = [];
							dataVal.Values.push([depart.id, depart.name]);
							dataVal.Value = depart.name;
						} else {
							dataVal.Values = [];
							dataVal.Value = "";
						}
					}
				})
			},
			getTemplate: async function() {
				var departs = this.logInfo.fullName;
				this.listLoading = true;
				var title = this.logInfo.fullName;
				var jobLevel = this.logInfo.JobLevel;
				getTemplateInfo(this.templateId).then(async response => {
					var controls = response.Body;
					console.log(controls);
          this.templateData = this.assignControl(controls, this.logInfo);
          this.templateData = await this.assignControlBySpNo(controls, null,this.flowId);
					this.listLoading = false;
				})
			},
			getEmployeeRelation: async function(empNo) {
				await getRelation(empNo).then(response => {
					this.relationList = response.Body[0].Nodes;
				});
			},
			getTextVal() {},
			getSelectorVal(val, name) {},
			tableOperation(val, type, datas) {
				if (type == 'compute') {
					return;
				}
				this.tableoperation(val, type, datas, this);
			},
			submit: async function() {
				var that = this;
				var IsReturn = false;
				isSubmit = true;
				this.listLoading = true;
				console.log("submit");
				//提交
				submitProcess(this.templateId, this.logInfo.EmpNo, this.spNo, this.templateData).then(response => {
					this.Message({
						message: '申请成功',
						type: 'success',
						duration: 3 * 1000
					});
					setTimeout(() => {
						this.$router.push("/index");
					}, 3000)
				}).finally(() => {
					isSubmit = false;
					this.listLoading = false;
					for (var i = 0; i < this.templateData.TemplateContent.Controls.length; i++) {
						var item = this.templateData.TemplateContent.Controls[i];
						if (item.Property.Title[0].Text == "申请内容") {
							item.Config.Table.Children.forEach(async (sonData) => {
								if (sonData.Property.Title[0].Text == "种类") {
									sonData.Property.Control = "SelectFilterTable";
									sonData.filterable = true;
									sonData.Options = [];
									await getAdministrativeProgressive("", "", "", "", "", "").then(res => {
										res.Body.forEach(item => {
											var data = {
												"Key": item,
												"Value": item
											};
											sonData.Options.push(data);
										});
									});

								}
								if (sonData.Property.Title[0].Text == "物品名称") {
									sonData.Property.Control = "SelectFilterTable";
									sonData.filterable = true;
								}
								if (sonData.Property.Title[0].Text == "规格型号") {
									sonData.Property.Control = "SelectFilterTable";
									sonData.filterable = true;
								}
								if (sonData.Property.Title[0].Text == "单位") {
									sonData.Property.Control = "SelectFilterTable";
									sonData.filterable = true;
								}
								if (sonData.Property.Title[0].Text == "单价") {
									sonData.Property.Control = "SelectFilterTable";
									sonData.filterable = true;
								}
							});
						}
					}

				});
			}
		},
		watch: {
			relationList(val, oldVal) {
				if (oldVal == null) {
					this.getTemplate();
				}
			},
			dialogVisible(val, old) {
				if (val) {
					setTimeout(() => {
						this.optBtn = true;
					}, 30000)
				} else {
					this.optBtn = false;
					this.timer = 30;
				}
			}
		}
	}
</script>

<style lang="less">
	.pages {
		padding-bottom: 14px;
	}

	.distribution-system-modal {
		padding: 0;
		margin-top: 10vh !important;

	}

	.distribution-system-modal .el-dialog__body {
		padding: 0 !important;
		max-height: 70vh !important;
		overflow: scroll !important;
	}

	.distribution-system-modal .el-dialog__header {
		display: none !important;
	}

	.distribution-system {
		width: 100%;
		height: auto;
	}
</style>
